<template>
  <div class="sf-hero-wrap">
    <v-img class="sf-hero"
           v-bind:aspect-ratio="$vuetify.breakpoint.xsOnly ? 1.6 : aspectRatio"
           v-bind:gradient="gradient"
           v-bind:src="imageSrc">
      <div class="sf-hero__content">
        <div class="sf-hero__bar">
          <div v-if="!!this.$slots['left-button']">
            <slot name="left-button" />
          </div>
          <v-spacer />
          <div class="sf-hero__bar-actions"
               v-if="!!this.$slots['right-button'] || !!this.$slots['menu']">
            <slot name="right-button" />
            <slot name="menu" />
          </div>
        </div>
        <div class="sf-hero__body">
          <slot>
            <h1 class="sf-hero__title white--text">{{ title }}</h1>
          </slot>
        </div>
      </div>
    </v-img>
  </div>
</template>

<script>
  export default {
    name: 'TopImageHeader',
    props: {
      aspectRatio: {
        default: 3.2,
        type: Number
      },
      imageSrc: String,
      title: String,
      gradient: {
        default: 'to bottom, rgba(17, 62, 124, .4), rgba(17, 62, 124, 1)',
        type: String
      }
    }
  }
</script>

<style scoped>
  .sf-hero__content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 16px;
  }

  .sf-hero__bar {
    align-items: center;
    display: flex;
    gap: 8px;
  }

  .sf-hero__bar-actions {
    align-items: center;
    display: flex;
    gap: 8px;
  }

  .sf-hero__body {
    margin-top: auto;
    padding: 24px 8px 8px;
  }

  @media (min-width: 600px) {
    .sf-hero__content {
      padding: 24px;
    }
  }
</style>
